import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import WorksPage from "./pages/WorksPage";
import AboutPage from "./pages/AboutPage";
import ReviewsPage from "./pages/ReviewsPage";
import InstallationsPage from "./pages/InstallationsPage";
import StorePage from "./pages/StorePage";
import ServicesPage from "./pages/ServicesPage";
import CollectPage from "./pages/CollectPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/works" element={<WorksPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/installations" element={<InstallationsPage />} />
          <Route path="/store" element={<StorePage />} />
          <Route path="/commissions" element={<ServicesPage />} />
          <Route path="/collect" element={<CollectPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
